<script lang="ts" setup>
import { computed } from 'vue';


    const props = withDefaults(defineProps<{
            value: boolean,
            trueText: string,   // Value must be between 1-12. Will be ignored if the titleClass is specified
            falseText: string
        }>(), 
        {
            trueText: "Yes",
            falseText: "No"
        });

    const emit = defineEmits(["update:value"]);


    function buttonState(assignedButtonVal: boolean)
    {
        return props.value === assignedButtonVal ? "btn btn-success me-1":"btn btn-light btn-outline-primary me-1";
    }

    const trueButtonClass = computed(() => buttonState(true));
    const falseButtonClass = computed(() => buttonState(false));

    function OnClick(newVal: boolean)
    {
        emit("update:value", newVal);
    }
</script>

<template>
    <button :class="trueButtonClass" @click="() => OnClick(true)">
        {{trueText}}
    </button>
    <button :class="falseButtonClass" @click="() => OnClick(false)">
        {{falseText}}
    </button>    
</template>